var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('LayoutMainAppBar'),_c('v-main',[_c('v-container',{class:_vm.xs ? 'pa-0' : null,attrs:{"fluid":""}},[_c('router-view')],1)],1),(!_vm.xs)?_c('LayoutMainFooter'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }